import { render } from "./UserProfileComponent.vue?vue&type=template&id=01e8352d"
import script from "./UserProfileComponent.vue?vue&type=script&lang=js"
export * from "./UserProfileComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__